import { CandidateDocuments, OperationResultOfCandidateDocuments, EmailAttachments, OperationResultOfEmailAttachments, ImmigrationEmailAttachments, ExitEmailAttachments, OperationResultOfExitEmailAttachments, OperationResultOfImmigrationEmailAttachments } from './api.gen';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from './api.gen';
import { HttpClient } from '@angular/common/http';
import { CommonService } from './common.service';
import { Logger } from '../utils/Logger';


@Injectable()
export class AttachmentUploadService {
    baseUrl: string;
    constructor(private http: HttpClient, private common: CommonService, @Inject(API_BASE_URL) baseUrl?: string) {
        this.baseUrl = baseUrl;
    }

    postFile(fileDetails: EmailAttachments, file?: File): Observable<OperationResultOfCandidateDocuments> {
        const url = this.baseUrl + '/api/Candidate/AttachmentsUpload';
        const formData: FormData = new FormData();
        formData.append('id', fileDetails.id.toString());
        formData.append('candidateId', fileDetails.candidateId.toString());
        formData.append('fileName', file.name);
        formData.append('employeeId', fileDetails.createdById.toString());
        formData.append('candidateActivityId', fileDetails.candidateActivityId.toString());
        formData.append('activityId', fileDetails.activityId.toString());
        formData.append('emailTemplateId', fileDetails.emailTemplateId.toString());

        if (fileDetails.id > 0) {
            formData.append('fileGuId', fileDetails.fileGuiId.toString());
            formData.append('modifiedById', fileDetails.modifiedById.toString());
        }
        if (file != null) {
            formData.append('file', file, file.name);
        }
        return this.http.post<OperationResultOfEmailAttachments>(url, formData);
    }

    postImmigrationFile(fileDetails: ImmigrationEmailAttachments, file?: File): Observable<OperationResultOfCandidateDocuments> {
        const url = this.baseUrl + '/api/Immigration/AttachmentsUpload';
        const formData: FormData = new FormData();
        formData.append('id', fileDetails.id.toString());
        formData.append('candidateId', fileDetails.candidateId.toString());
        formData.append('fileName', file.name);
        formData.append('employeeId', fileDetails.createdById.toString());
        formData.append('immigrationProfileActivityId', fileDetails.immigrationProfileActivityId.toString());
        formData.append('activityId', fileDetails.activityId.toString());
        formData.append('emailTemplateId', fileDetails.emailTemplateId.toString());

        if (fileDetails.id > 0) {
            formData.append('fileGuId', fileDetails.fileGuiId.toString());
            formData.append('modifiedById', fileDetails.modifiedById.toString());
        }
        if (file != null) {
            formData.append('file', file, file.name);
        }
        return this.http.post<OperationResultOfEmailAttachments>(url, formData);
    }

    exitEmailFile(fileDetails: ExitEmailAttachments, file?: File): Observable<OperationResultOfExitEmailAttachments> {
        const url = this.baseUrl + '/api/Exit/AttachmentsUpload';
        const formData: FormData = new FormData();
        formData.append('id', fileDetails.id.toString());
        formData.append('requestId', fileDetails.requestId.toString());
        formData.append('fileName', file.name);
        formData.append('employeeId', fileDetails.createdById.toString());
        formData.append('exitRequestActivityId', fileDetails.exitRequestActivityId.toString());
        formData.append('activityId', fileDetails.activityId.toString());
        formData.append('emailTemplateId', fileDetails.emailTemplateId.toString());

        if (fileDetails.id > 0) {
            formData.append('fileGuId', fileDetails.fileGuiId.toString());
            formData.append('modifiedById', fileDetails.modifiedById.toString());
        }
        if (file != null) {
            formData.append('file', file, file.name);
        }
        return this.http.post<OperationResultOfExitEmailAttachments>(url, formData);
    }


    downloadAttachment(details): void {

        const fileUrl = this.baseUrl + "/api/Candidate/DownloadAttachment";
        this.http.post<Blob>(fileUrl, details, { responseType: 'Blob' as 'json' })
            .subscribe(resp => {



                const fileName = details.fileName;

                // const fileName = this.common.getFilename(details);
                // details.documentName.replace(/ +/g, "_")
                //     + this.common.getFileExtension(details.fileName);

                if ((window.navigator as any).msSaveOrOpenBlob) {
                    (window.navigator as any).msSaveBlob(resp, fileName);
                } else {
                    const url = window.URL.createObjectURL(resp);
                    const a = document.createElement("a");
                    document.body.appendChild(a);
                    a.setAttribute("style", "display: none");
                    a.href = url;
                    a.download = fileName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    a.remove();
                }
            },
                error => {
                    Logger.error(error);
                });
    }

    downloadImmigrationAttachment(details): void {

        const fileUrl = this.baseUrl + "/api/Immigration/DownloadAttachment";
        this.http.post<Blob>(fileUrl, details, { responseType: 'Blob' as 'json' })
            .subscribe(resp => {



                const fileName = details.fileName;

                // const fileName = this.common.getFilename(details);
                // details.documentName.replace(/ +/g, "_")
                //     + this.common.getFileExtension(details.fileName);

                if ((window.navigator as any).msSaveOrOpenBlob) {
                    (window.navigator as any)
                        .msSaveBlob(resp, fileName);
                } else {
                    const url = window.URL.createObjectURL(resp);
                    const a = document.createElement("a");
                    document.body.appendChild(a);
                    a.setAttribute("style", "display: none");
                    a.href = url;
                    a.download = fileName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    a.remove();
                }
            },
                error => {
                    Logger.error(error);
                });
    }

    downloadAttachmentsAll(id: number, typeId: number): Observable<Blob> {
        let url = this.baseUrl + `/api/Candidate/AttachmentsDownloadAll?id=${id}`;
        if (typeId > 0) {
            url = url + `&typeId=${typeId}`;
        }
        return this.http.post<Blob>(url, id, { responseType: 'Blob' as 'json' });
    }

    postFileTemplate(fileDetails: EmailAttachments, file?: File): Observable<OperationResultOfCandidateDocuments> {

        const url = this.baseUrl + '/api/Email/TemplateAttachmentsUpload';
        const formData: FormData = new FormData();
        formData.append('fileName', file.name);
        formData.append('emailTemplateId', fileDetails.emailTemplateId.toString());

        if (file != null) {
            formData.append('file', file, file.name);
        }
        return this.http.post<OperationResultOfEmailAttachments>(url, formData);
    }


}
